import { render, staticRenderFns } from "./placement.vue?vue&type=template&id=1f176ebe&"
import script from "./placement.vue?vue&type=script&lang=ts&"
export * from "./placement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports